<template>
  <section>
    <div class="container">
      <div class="handle-box">
        <el-row type="flex" justify="space-between">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-select
              size="small"
              v-model="alarm_status"
              default-first-option
              style="width:200px;"
              @change="changeStatus()"
            >
              <el-option key="3" label="报警处理" value="3"></el-option>
              <el-option key="2" label="所有报警" value="2"></el-option>
              <el-option key="1" label="已处理" value="1"></el-option>
              <el-option key="0" label="未处理" value="0"></el-option>
            </el-select>
            <a style="margin-left: 15px;" href="#" @click="getMonthlyData"
              >最近30天</a
            >
            <a style="margin-left: 15px" href="#" @click="getWeeklyData"
              >最近7天</a
            >
            <a style="margin-left: 15px" href="#" @click="getHourlyData"
              >最近1小时</a
            >
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-date-picker
              :picker-options="pickerOptions"
              v-model="queryTime"
              type="datetimerange"
              align="right"
              size="small"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
            <el-button
              size="small"
              icon="el-icon-search"
              style="margin-left: 10px;"
              type="primary"
              @click="getData"
              >查询</el-button
            >
            <el-button size="small" @click="exportXlsx">导出</el-button>
          </el-col>
        </el-row>
      </div>

      <el-table
        :data="tableData"
        @selection-change="checkIds"
        stripe
        v-loading="loading"
      >
        <el-table-column type="selection" width="65px" align="right"></el-table-column>
        <el-table-column prop="aid" v-if="false"></el-table-column>
        <el-table-column prop="record_time" label="报警时间" align="center" :formatter="formatTime"></el-table-column>
        <el-table-column prop="var_name" label="报警变量" align="center"></el-table-column>
        <el-table-column prop="alarm_name" label="报警名称" align="center"></el-table-column>
        <el-table-column prop="alarm_content" label="报警详情" align="center"></el-table-column>
        <el-table-column prop="alarm_status" label="是否处理" align="center">
          <div slot-scope="scope">
            <span v-if="scope.row.alarm_status === '0'">未处理</span>
            <span v-if="scope.row.alarm_status === '1'">已处理</span>
          </div>
        </el-table-column>
        <el-table-column label="报警处理">
          <div slot-scope="scope">
            <el-button
              size="small"
              type="warning"
              plain
              :disabled="scope.row.alarm_status === '1'"
              @click="almHandle(scope.row.arid)"
            >
              确认
            </el-button>
          </div>
        </el-table-column>
      </el-table>
      <div class="cms-list-footer">
        <div class="cms-left">
          <el-button size="small" :disabled="disabled" @click="almHandle(ids)"
            >批量处理</el-button
          >
        </div>
        <!-- 分页组件 -->
        <cms-pagination :total="total" @change="getPages"></cms-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import listMixins from "@/mixins/list";
import expxls from "@/untils/exportxlsx";
export default {
  mixins: [listMixins],
  name: "AlarmList",
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      isVisible: false,
      header: [
        "报警时间",
        "报警名称",
        "报警变量",
        "报警详情",
        "是否处理[0:未/1:已]"
      ],
      params: {
        pageNo: "1",
        pageSize: "10",
        uid: "",
        start: "",
        end: ""
      },
      ids: "",
      queryTime: ["", ""],
      columns: [
        { prop: "record_time", label: "采集时间" },
        { prop: "alarm_name", label: "报警名称" },
        { prop: "var_name", label: "报警变量" },
        { prop: "alarm_content", label: "报警详情" },
        { prop: "alarm_status", label: "是否处理[0:未/1:已]" }
      ],
      selectDatas: [],
      alarm_status: "3"
    };
  },
  methods: {
    changeStatus() {
      if (this.alarm_status == "3") {
        //状态
        return;
      }
      if (this.alarm_status == "2") {
        //全部
        this.params.alarm_status = "";
        this.initTableData("AlarmRec/PagedView", this.params);
      } else {
        this.params.alarm_status = this.alarm_status;
        this.initTableData("AlarmRec/PagedView", this.params);
      }
    },
    exportXlsx() {
      document.body.style.cursor = "wait"; //导出时，改变鼠标状态为等待
      if (this.selectDatas.length > 0) {
        //多选框导出
        const datetime = Date.now();
        const filename = "报警数据" + datetime;
        expxls(this.selectDatas, this.columns, filename);
      } else {
        let self = this;
        this.$api
          .post("AlarmRec", this.params)
          .then(res => {
            if (res.status === 200) {
              let arrs = JSON.parse(res.data);
              const datetime = Date.now();
              const filename = "报警数据" + datetime;
              expxls(arrs, self.columns, filename);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    getData() {
      this.initTableData("AlarmRec/PagedView", this.params); //加载数据
    },
    formatTime(row, column, cellValue, index) {
      //修正时间格式，形如2018-10-08 11:10:05
      if(cellValue){return cellValue.replace("T", " ").substring(0, 19);}
      else{return ''}
    },
    timeInit(day) {
      this.queryTime = [];
      var now = new Date();
      var premonth = new Date(now.getTime() - day * 24 * 3600 * 1000);
      this.queryTime.push(premonth);
      this.queryTime.push(now);
      this.params.start = this.queryTime[0];
      this.params.end = this.queryTime[1];
    },
    timeChange() {
      if (this.queryTime) {
        this.params.start = this.queryTime[0];
        this.params.end = this.queryTime[1];
      } else {
        this.params.start = null;
        this.params.end = null;
      }
    },
    checkIds(val) {
      let ids = [];
      this.selectDatas = [];
      for (let i in val) {
        this.selectDatas.push(val[i]);
        if (val[i].alarm_status === '0') {
          ids.push(val[i].arid);//压入未处理的，已选择的报警
        }
      }
      this.ids = ids.join(",");
      this.disabled = ids.length > 0 ? false : true;
    },
    almHandle(arids) {
      //报警处理
      this.$api
        .post("AlarmRec/Confirm", { ids: arids })
        .then(res => {
          if (res.status === 200) {
            //处理成功，刷新数据
            this.getData();
          }
        })
        .catch(err => {
          console.log("err");
        });
    },
    getMonthlyData() {
      this.timeInit(30);
      this.getData();
    },
    getWeeklyData() {
      this.timeInit(7);
      this.getData();
    },
    getHourlyData() {
      this.timeInit(1 / 24);
      this.getData();
    }
  },
  mounted() {},
  created() {
    this.params.uid = this.$store.state.userInfo.id;
    if(this.$route.query.status){
      this.params.status=this.$route.query.status;
      this.alarm_status=this.$route.query.status;
    }
    this.timeInit(30);
    this.getData();
  }
};
</script>
